import React from 'react';

import LockedProductConfirmationCard from './LockedProductConfirmationCard/index.tsx';
import ProductDeliveryConfirmationCard from './ProductDeliveryConfirmationCard/index.tsx';
import ProductSupportCard from './ProductSupportCard/index.tsx';
import ProductDeliveryConfirmedCard from './ProductDeliveryConfirmedCard/index.tsx';
import { useAppSelector } from '../../../redux/hooks.ts';
import { ihutSelectors } from '../../../redux/slices/ihut.ts';
import { IhutActivity } from '../../../api/ihut.ts';

const ProductConfirmationCard = () => {
  const activity = useAppSelector(
    ihutSelectors.selectSelectedActivity
  ) as IhutActivity;
  const status = activity.supportCardStatus;

  if (status === 'on-the-way')
    return <LockedProductConfirmationCard status={status} />;

  if (status === 'delivered')
    return <ProductDeliveryConfirmationCard status={status} />;

  if (status === 'in-support') return <ProductSupportCard status={status} />;

  if (status === 'confirmed')
    return (
      <ProductDeliveryConfirmedCard
        status={status}
        deliveryDate={activity.deliveryConfirmedOn as string}
      />
    );

  return null;
};

export default ProductConfirmationCard;
